const LocalStorageService = (function () {
  var _service;
  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }
    return _service;
  }

  function _setToken(tokenObj) {
    sessionStorage.setItem("mict_access_token", tokenObj.access_token);
    sessionStorage.setItem("mict_refresh_token", tokenObj.refresh_token);
  }

  function _getTokens() {
    return (
      sessionStorage.getItem("mict_access_token") &&
      sessionStorage.getItem("mict_refresh_token")
    );
  }

  function _getAccessToken() {
    return sessionStorage.getItem("mict_access_token");
  }

  function _getRefreshToken() {
    return sessionStorage.getItem("mict_refresh_token");
  }

  function _removeTokens() {
    sessionStorage.removeItem("mict_access_token");
    sessionStorage.removeItem("mict_refresh_token");
    sessionStorage.removeItem("mict_auth_details");
    sessionStorage.removeItem("selected_project");
    sessionStorage.removeItem("selected_filter");
    sessionStorage.removeItem("comment_status");
    sessionStorage.removeItem("assignedId");
    sessionStorage.removeItem("currentPage");
    sessionStorage.removeItem("totalPaginationCount");
    sessionStorage.removeItem("currentPageCount");

  }

  function _customHeaders() {
    return { token: _getAccessToken() };
  }

  function _setAuthDetails(auth_details) {
    sessionStorage.setItem("mict_auth_details", auth_details);
  }

  function _getAuthDetails() {
    return sessionStorage.getItem("mict_auth_details");
  }

  //Cookies
  function _setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function _getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function _checkCookie(cname) {
    let user = _getCookie(cname);
    if (user !== "") {
      return true;
    } else {
      _setCookie(cname, "guest", 365);
      return false;
    }
  }

  function _setSelectedProject(details) {
    sessionStorage.setItem("selected_project", details);
  }

  function _getSelectedProject() {
    return sessionStorage.getItem("selected_project");
  }

  function _setSelectedFilter(selected_filter){
    sessionStorage.setItem("selected_filter", selected_filter);
  }

  function _getSelectedFilter() {
    return sessionStorage.getItem("selected_filter");
  }

  function _setCommentStatus(comment_status){
    sessionStorage.setItem("comment_status",comment_status);
  }

  function _getCommentStatus(){
    return sessionStorage.getItem("comment_status");
  }

 function setAssignedId(id) {
  sessionStorage.setItem("assignedId", id);
}

function getAssignedId() {
  return sessionStorage.getItem("assignedId");
}

function _setTotalPaginationCount(totalPaginationCount){
  sessionStorage.setItem("totalPaginationCount",totalPaginationCount);
}

function _getTotalPaginationCount() {
  return sessionStorage.getItem("totalPaginationCount");
}

function _setCurrentPage(currentPage){
  sessionStorage.setItem("currentPage", currentPage);
}

function _getCurrentPage(){
  return sessionStorage.getItem("currentPage");
}

function _setCurrentPageCount(currentPageCount) {
  sessionStorage.setItem("currentPageCount", currentPageCount);
}

function _getCurrentPageCount() {
  return sessionStorage.getItem("currentPageCount");
}

  return {
    getService: _getService,
    setToken: _setToken,
    getTokens: _getTokens,
    setAuthDetails: _setAuthDetails,
    getAuthDetails: _getAuthDetails,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    removeTokens: _removeTokens,
    customHeaders: _customHeaders,
    getCookie: _getCookie,
    setCookie: _setCookie,
    checkCookie: _checkCookie,
    setProjectDetails: _setSelectedProject,
    getProjectDetails: _getSelectedProject,
    setSelectedFilter: _setSelectedFilter,
    getSelectedFilter: _getSelectedFilter,
    setCommentStatus: _setCommentStatus,
    getCommentStatus: _getCommentStatus,
    setAssignedId: setAssignedId,
    getAssignedId: getAssignedId,
    setTotalManuscriptCountToSession: _setTotalPaginationCount,
    getTotalPaginationCount: _getTotalPaginationCount,
    setCurrentPageToSession: _setCurrentPage,
    getCurrentPage: _getCurrentPage,
    setCurrentPageCount: _setCurrentPageCount,
    getCurrentPageCount:_getCurrentPageCount,

  };
})();

export default LocalStorageService;
/* Function to handle Local Storage Items */
